import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

function CompPrev({ products }) {
  return (
    <div className='bg-white h-full rounddash'>
      <div>
        <h2 className='text-xl font-bold text-left'>Artikel Berhasil</h2>
      </div>
      <div className='w-full mt-3'>
        <DataTable
          value={products}
          showGridlines
          sortMode='multiple'
          tableStyle={{ minWidth: '50rem' }}
        >
          <Column field='Code' header='Code' className='w-2/12'></Column>
          <Column
            field='Artikel'
            sortable
            header='Artikel'
            className='w-6/12'
          ></Column>
          <Column
            field='Size'
            sortable
            header='Size'
            className='w-3/12'
          ></Column>
          <Column
            field='Quantity'
            sortable
            header='Qty'
            className='w-1/12'
          ></Column>
        </DataTable>
      </div>
    </div>
  );
}

export default CompPrev;
